import React from 'react';
import {
  CoverStop, ObjectivesStop, OverviewStop, HookStop, StepStop, SelectTypeStop, DividerStop,
  PipelineStop, GlossaryStop, QuizStop, ResultsStop, OutroStop,
  HandDemoStop, BillSplitStop, CalcTraceStop, OpTableStop, PrecedenceStop,
} from './stops.jsx';
import CamTagsStop from './camtags/CamTagsStop.jsx';
import { NameTagStop, NameRulesStop, CountMeasureStop, TypeOfStop, SummaryStop, TagCoverStop } from './tagStops.jsx';
import './themeTag.css';

const REGISTRY = {
  cover: CoverStop,
  objectives: ObjectivesStop,
  overview: OverviewStop,
  hook: HookStop,
  step: StepStop,
  'select-type': SelectTypeStop,
  divider: DividerStop,
  pipeline: PipelineStop,
  glossary: GlossaryStop,
  quiz: QuizStop,
  results: ResultsStop,
  outro: OutroStop,
  hand_demo: HandDemoStop,
  'bill-split': BillSplitStop,
  'calc-trace': CalcTraceStop,
  'op-table': OpTableStop,
  precedence: PrecedenceStop,
  'name-tag': NameTagStop,
  'name-rules': NameRulesStop,
  'count-measure': CountMeasureStop,
  'type-of': TypeOfStop,
  summary: SummaryStop,
  'cam-tags': CamTagsStop,
};

/**
 * `preview` marks the miniature copies the control panel shows of the current
 * and next slide. A slide that asks for the camera or throws confetti must
 * not do either in a 300px box on the instructor's desk, so the few stops
 * that reach outside themselves check this flag.
 */
export default function DeckStop({ stop, substep, deck, room, findQuestion, onOpenQr, preview = false }) {
  // The tag lesson's cover is drawn by its own theme; every other deck keeps the shared one.
  const Comp = stop.kind === 'cover' && deck.meta?.theme === 'tag' ? TagCoverStop : REGISTRY[stop.kind];
  if (!Comp) return <section className="stop stop-pad"><h1 className="stop-title">{stop.kind}</h1></section>;
  return (
    <Comp
      stop={stop}
      substep={substep}
      deck={deck}
      room={room}
      findQuestion={findQuestion}
      onOpenQr={onOpenQr}
      preview={preview}
    />
  );
}
